import React, { useState, useEffect } from 'react';
import { useI18n } from '../../i18n';
import { auth } from '../../api/client';
import { FileUploadScanner, AntivirusDashboard } from '../../components/Antivirus';
import { Shield, Upload, Settings, Activity } from 'lucide-react';

const AntivirusPage = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState('scanner');
  const [userRole, setUserRole] = useState(null);
  const [isSuperuser, setIsSuperuser] = useState(false);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const userData = await auth.getCurrentUser();
        setUserRole(userData?.role || '');
        setIsSuperuser(userData?.is_superuser || false);
      } catch (error) {
        console.error('Error fetching user role:', error);
      }
    };
    fetchUserRole();
  }, []);

  const isSuperAdmin = userRole === 'super_admin' || isSuperuser;

  const tabs = [
    {
      id: 'scanner',
      label: t('antivirus.scannerTab', 'File Scanner'),
      icon: Upload,
      component: FileUploadScanner
    }
  ];

  // Add admin tab for superadmins
  if (isSuperAdmin) {
    tabs.push({
      id: 'admin',
      label: t('antivirus.adminTab', 'Administration'),
      icon: Settings,
      component: AntivirusDashboard
    });
  }

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || FileUploadScanner;

  return (
    <div className="flex-1 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 rounded-xl bg-purple-500/20 border border-purple-500/30">
              <Shield className="w-8 h-8 text-purple-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white">
                {t('antivirus.title', 'Antivirus Scanner')}
              </h1>
              <p className="text-gray-400">
                {t('antivirus.subtitle', 'Scan files for malware using ClamAV')}
              </p>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="mb-6">
          <div className="flex gap-2 p-1 bg-gray-900/50 rounded-lg border border-gray-700/50 w-fit">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                    activeTab === tab.id
                      ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30'
                      : 'text-gray-400 hover:text-white hover:bg-gray-800/50'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Active Tab Content */}
        <ActiveComponent />
      </div>
    </div>
  );
};

export default AntivirusPage;
